export default __webpack_public_path__ + "static/1-a8b7f4779a3c8287f2d47911f32099c9.jpeg";